import styles from "../../styles/steps.module.scss";

export const Steps = ({ steps, currentStep, onClick, children }) => {
  return (
    <div className={styles.stepsContainer}>
      <div className={styles.steps}>
        {Array(steps)
          .fill(0)
          .map((step, _i) => {
            return (
              <span
                key={_i}
                className={`${styles.step} ${
                  currentStep > _i ? styles.active : ""
                }`}
                onClick={() => onClick && onClick(_i)}
              />
            );
          })}
      </div>

      {children}
    </div>
  );
};
